import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import useTermCategories from '@hooks/term/useTermCategories';
import useProject from '@hooks/useProject';
import { Link } from '@router/Link';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

function MainFooter() {
    const terms = useTermCategories('MAIN');
    const project = useProject();
    const { t } = useTranslation('main', { keyPrefix: 'footer' });
    if (project?.businessProfile) {
        const arr:string[] = [];
        const {
            brandName, bizName, nameEn, representativeName,
            businessRegistrationNumber, salesReportNumber, addrRoad, addrDetail, email, contact,
        } = project.businessProfile;
        if (brandName) {
            arr.push(brandName);
        }
        arr.push(bizName);
        if (nameEn) {
            arr.push(nameEn);
        }
        arr.push(`${t('representativeName')}: ${representativeName}`);
        arr.push(`${t('businessRegistrationNumber')}: ${businessRegistrationNumber}`);
        arr.push(`${t('salesReportNumber')}: ${salesReportNumber}`);
        arr.push(`${t('address')}: ${addrRoad} ${addrDetail ? `, ${addrDetail}` : ''}`);
        arr.push(`${t('email')}: ${email}`);
        if (contact) {
            arr.push(`${t('contact')}: ${contact}`);
        }
        const content = arr.join('\n');
        return (
            <Container>
                <Text size='s' color={colors.gray7}
                    css={css`white-space: pre-wrap`} >
                    {content}
                </Text>
                <br/>
                <Row spacing={8}>
                    {terms?.map((termCategory, index) => (
                        <Fragment key={termCategory.id}>
                            <Link activityName='TermDetailActivity'
                                activityParams={{ termCategoryId: termCategory.id }}>
                                <Text size='s' fontWeight='medium' color={colors.gray7}>
                                    {termCategory.title}
                                </Text>
                            </Link>
                            {index + 1 !== terms.length && (
                                <Text size='s'>|</Text>
                            )}
                        </Fragment>
                    ))}
                </Row>
            </Container>
        );
    }
    return (<Fragment/>);
}

const Container = styled.div`
    width: 100%;
    background-color: ${colors.gray1};
    padding: 16px 20px 48px;
`;

export default MainFooter;
